import { render } from "./WatchlistDetailWindow.vue?vue&type=template&id=65a6b6a1&scoped=true"
import script from "./WatchlistDetailWindow.vue?vue&type=script&lang=js"
export * from "./WatchlistDetailWindow.vue?vue&type=script&lang=js"

import "./WatchlistDetailWindow.vue?vue&type=style&index=0&id=65a6b6a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a6b6a1"]])

export default __exports__